import { render, staticRenderFns } from "./ModifyBudget.vue?vue&type=template&id=2823b691"
import script from "./ModifyBudget.vue?vue&type=script&lang=js"
export * from "./ModifyBudget.vue?vue&type=script&lang=js"
import style0 from "./ModifyBudget.vue?vue&type=style&index=0&id=2823b691&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports